export default {
      id: "structure-usage",
      viewBox: "0 0 18 17",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#structure",
      toString: function () {
        return this.url;
      }
    }